var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCzHousing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 21v35h58V21H9zm54 31H32v-6H20v6h-7V25h50v27zm-4-5h-6v-6h6v6zm0-12h-6v-6h6v6zM47 47h-6v-6h6v6zm0-12h-6v-6h6v6zm-12 0h-6v-6h6v6zm-12 0h-6v-6h6v6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/CZ_Housing.ad7f792d.svg";
export { SvgCzHousing as ReactComponent };